<template>
<v-app>
  <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
  <prb-terms v-bind:termsDialog="!terms"></prb-terms>
  <main>
    <v-container fluid>
      <prb-loading v-if="loading"></prb-loading>
      <v-layout class="target__layout text-xs-center" v-if="errorPage" style="min-height:70vh;" align-center>
        <v-flex xs12 class="pa-5 white">
          <span class="title white">
            <b>
              <v-icon style="margin-bottom:3px;margin-right:3px;">error_outline</v-icon>
              Error: Data not found</b>
            </span>
        </v-flex>
      </v-layout>
      <v-layout class="target__layout" v-if="sorted20 && target && !loading && !errorPage">
        <v-flex xs12>
          <div class="target_layout__content elevation-1">
            <v-flex xs12 class="pa-0">
              <div class="target-top__layout__summary-title">{{titleName}}</div>
            </v-flex>
            <v-layout row wrap justify-end v-if="portalList.length || unmapped.length">
              <div class="row">
                <div class="col">
                  <a class="target-top__layout__portal-links" target="_blank"
                     href="http://www.chemicalprobes.org/">
                     <img height="30" class="mt-2"
                     src="http://www.chemicalprobes.org/sites/all/themes/zurb_foundation/images/cp-img/chemical-probes-logo@2x.png"/>
                  </a>
                </div>
                <div class="col mb-1 mr-2 text-xs-left pa-2">
                  <a :href="'http://www.chemicalprobes.org/search/site/' + titleName" style="text-decoration:none;"
                     target="_blank">
                     <v-btn style="background:#455A64;" class="white--text" v-if="!portalList.length && unmapped.length">
                       {{unmapped.length}} additional probes
                     </v-btn>
                     <v-btn style="background:#455A64;" class="white--text" v-if="portalList.length && !unmapped.length">
                       {{portalList.length}} common probes
                     </v-btn>
                     <v-btn style="background:#455A64;" class="white--text" v-if="portalList.length && unmapped.length">
                        {{portalList.length}} common probes, {{unmapped.length}} additional probes
                    </v-btn>
                  </a>
                </div>
              </div>
            </v-layout>

            <prb-target-top :target="target"></prb-target-top>
            <v-layout row wrap>
              <v-flex xs12>
                <div class="target-probes__layout-title">
                  ASSESSED COMPOUNDS ({{Object.keys(probes.metadata).length}})
                </div>
              </v-flex>
              <v-navigation-drawer class="teal darken-1" persistent height="100%" v-model="drawer">
                <v-layout row wrap align-center>
                  <v-flex xs6 class="text-xs-left">
                    <p class="title target-probes__layout__content__setting-btn white--text">SETTINGS</p>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right">
                    <v-btn fab flat light small @click.native.stop="drawer = !drawer">
                      <v-icon light class="white--text">clear</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 class="pt-0 pr-3 pl-4">
                    <v-switch @change="changeEnableWeights" v-bind:label="customFiltersFlag ? 'Disable Custom Weights' : 'Enable Custom Weights'" v-model="customFiltersFlag" dark></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if="customFiltersFlag">
                    <p class="body-2 white--text pl-3">CUSTOM VALUES WEIGHTS:</p>
                    <div class="pl-3 pr-3">
                      <v-layout row wrap align-center>
                        <v-flex xs12 class="pa-2">
                          <span class="body-1 white--text">SELECTIVITY (0 - {{filtersCustom.selectivity}})</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap align-center>
                            <v-flex xs2 class="text-xs-center white--text">0</v-flex>
                            <v-flex xs8 class="text-xs-left">
                              <input step="0.1" class="range-slider" type="range" min="0" max="10" v-model="filtersCustom.selectivity">
                            </v-flex>
                            <v-flex xs2 class="text-xs-center white--text">10</v-flex>
                          </v-layout>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap align-center>
                        <v-flex xs12 class="pa-2">
                          <span class="body-1 white--text">TARGET POTENCY (0 - {{filtersCustom.target_potency}})</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap align-center>
                            <v-flex xs2 class="text-xs-center white--text">0</v-flex>
                            <v-flex xs8 class="text-xs-left">
                              <input step="0.1" class="range-slider" type="range" min="0" max="10" v-model="filtersCustom.target_potency">
                            </v-flex>
                            <v-flex xs2 class="text-xs-center white--text">10</v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap align-center>
                        <v-flex xs12 class="pa-2">
                          <span class="body-1 white--text">CELL POTENCY (0 -  {{filtersCustom.cell_potency}})</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap align-center>
                            <v-flex xs2 class="text-xs-center white--text">0</v-flex>
                            <v-flex xs8 class="text-xs-left">
                              <input step="0.1" class="range-slider" type="range" min="0" max="10" v-model="filtersCustom.cell_potency">
                            </v-flex>
                            <v-flex xs2 class="text-xs-center white--text">10</v-flex>
                          </v-layout>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap align-center>
                        <v-flex xs12 class="pa-2">
                          <span class="body-1 white--text">INACTIVE ANALOGS (0 - {{filtersCustom.inactive_analogs}})</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap align-center>
                            <v-flex xs2 class="text-xs-center white--text">0</v-flex>
                            <v-flex xs8 class="text-xs-left">
                              <input step="0.1" class="range-slider" type="range" min="0" max="10" v-model="filtersCustom.inactive_analogs" style="width:100%;">
                            </v-flex>
                            <v-flex xs2 class="text-xs-center white--text">10</v-flex>
                          </v-layout>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap align-center>
                        <v-flex xs12 class="pa-2">
                          <span class="body-1 white--text">SAR (0 - {{filtersCustom.sar}})</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap align-center>
                            <v-flex xs2 class="text-xs-center white--text">0</v-flex>
                            <v-flex xs8 class="text-xs-left">
                              <input step="0.1" class="range-slider" type="range" min="0" max="10" v-model="filtersCustom.sar" style="width:100%;">
                            </v-flex>
                            <v-flex xs2 class="text-xs-center white--text">10</v-flex>
                          </v-layout>
                          </v-flex>
                      </v-layout>
                      <v-layout row wrap align-center>
                        <v-flex xs12 class="pa-2">
                          <span class="body-1 white--text">PAINS (0 - {{filtersCustom.pains}})</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap align-center>
                            <v-flex xs2 class="text-xs-center white--text">0</v-flex>
                            <v-flex xs8 class="text-xs-left">
                              <input step="0.1" class="range-slider" type="range" min="0" max="10" v-model="filtersCustom.pains" style="width:100%;">
                            </v-flex>
                            <v-flex xs2 class="text-xs-center white--text">10</v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <div class="text-xs-center">
                        <v-btn outline class="white--text" dark @click.native="setDefaultWeights">SET DEFAULT WEIGHTS</v-btn>
                      </div>
                      <div class="text-xs-center">
                        <v-btn outline class="white--text" dark @click.native="changeCustom">APPLY SELECTED WEIGHTS</v-btn>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <p class="body-2 white--text pt-3 pl-3">SORT BY:</p>
                    <div class="section group pa-1">
                    	<div v-for="v in displayValues" v-on:click="changeSort(v.name)" class="col" v-bind:style="{ background: sort === v.name ? 'white' : null,  color: sort === v.name ? 'black' : null}">{{v.title}}</div>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <p class="body-2 white--text pt-3 pl-3">DISPLAY VALUE:</p>
                    <div class="section group pa-1">
                    	<div v-for="v in displayValues" v-on:click="changeDisplay(v.name);" class="col" v-bind:style="{ background: display === v.name ? 'white' : null,  color: display === v.name ? 'black' : null}">{{v.title}}</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-navigation-drawer>
            </v-layout>
            <v-flex xs12 class="pb-1">
              <v-flex xs12 class="pa-0 ma-1 elevation-1">
                <v-toolbar class="teal lighten-2 elevation-0 pa-2" dark>
                  <v-toolbar-title>{{sorted20.length}} HIGHEST RATED</v-toolbar-title>
                  <v-btn fab flat dark small class="teal darken-1" @click.native.stop="drawer = !drawer">
                    <v-icon dark>settings</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn class="blue-grey darken-2" @click.native="goToAll()">DISPLAY ALL</v-btn>
                </v-toolbar>
                <prb-target-compounds :all="Object.keys(probes.metadata).length" :sorted20="sorted20" :settings="{sort:sort, display:display}" :distribution="distribution" v-if="sorted20 && !loading"></prb-target-compounds>
              </v-flex>
            </v-flex>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
  <prb-footer></prb-footer>
</v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import PrbLoading from '././PrbLoading';
import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbFooter from './prb-footer/PrbFooter';
import PrbTargetTop from './prb-target/prb-target-top/PrbTargetTop';
import PrbTargetCompounds from './prb-target/prb-target-compounds/PrbTargetCompounds';

export default {
  metaInfo() {
    return {
      title: this.titleName || ' ',
      titleTemplate: 'Probe Miner | %s'
    }
  },
  components: {
    PrbLoading,
    PrbToolbar,
    PrbTerms,
    PrbTargetTop,
    PrbTargetCompounds,
    PrbFooter
  },
  data() {
    return {
      errorPage: false,
      displayValues: [
        {title:'Global Score', name: 'global'},
        {title:'Selectivity', name: 'selectivity'},
        {title:'Target Potency', name: 'target_potency'},
        {title:'Cell Potency', name: 'cell_potency'},
        {title:'SAR', name: 'sar'},
        {title:'Inactive Analogs', name: 'inactive_analogs'},
        {title:'Pains', name: 'pains'}
      ],
      distribution: {
        categories: null,
        values: null
      },
      titleName: '',
      target: null,
      probes: null,
      portalList: [],
      portalList20: [],
      portalListRest: [],
      unmapped: [],
      sorted20: null,
      drawer: false,
      sort: 'global',
      display: 'global',
      customFiltersFlag: false,
      filtersCustom: {
        selectivity: 1,
        target_potency: 1,
        sar: 1,
        cell_potency: 1,
        inactive_analogs: 1,
        pains: 1
      }

    }
  },
  computed: mapGetters([
    'termsVerified', 'loading'
  ]),
  name: 'prbcompoundsynopsis',
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    },
    loading: {
      get() {
        return this.$store.state.loading
      }
    }
  },
  mounted() {
    let that = this;

    that.portalList = [];
    that.portalList20 = [];
    that.portalListRest = [];

    that.$store.dispatch("SET_LOADING");

    this.$store.dispatch("GET_TARGET_RESULTS_BY_ID", this.$route.params.id).then(function(res) {

      that.target = that.$store.state.targetResultsList;

      if (that.target) {
        that.titleName = that.target.name;
        that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function(res) {
          that.probes = that.$store.state.probesResultsList;
          if (that.$store.state.portalList) {
            that.portalList20 = that.$store.state.portalList.in_top_20;
            that.portalListRest = that.$store.state.portalList.not_in_top_20;
            that.unmapped = that.$store.state.portalList.unmapped;

            that.portalList20.map(function(m, i){
              that.portalList.push({name:m, top:true})
            })

            that.portalListRest.map(function(m, i){
              that.portalList.push({name:m, top:false})
            })

            that.$store.dispatch("UNSET_LOADING");

            that.getFirst20(that.sort);
          } else  {
            that.errorPage = true
            that.$store.dispatch("UNSET_LOADING");
          }
        })
      } else {
        that.errorPage = true
        that.$store.dispatch("UNSET_LOADING");
      }
    });
  },
  methods: {
    goToAll() {
      this.$router.push('/' + this.$route.params.id + '/compounds');
    },
    getFirst20(sort) {

      this.$store.dispatch("SET_LOADING");

      let that = this;

      let sorted20KeysBySort = that.probes.top20[sort];
      let sorted20 = [];

      sorted20KeysBySort.map(function (key, i) {
        sorted20.push(that.probes.metadata[key])
      });

      sorted20.map(function (m, i) {
        m['idc'] = sorted20KeysBySort[i];
        m['namec'] = m.name;
      });

      that.sorted20 = sorted20;
      that.distribution = that.probes.distributions[that.display];

      this.$store.dispatch("UNSET_LOADING");
    },
    changeSort(name) {
      this.sort = name;

      this.$store.dispatch("SET_LOADING");

      let that = this;

      let sorted20KeysBySort = that.probes.top20[name];
      let sorted20 = [];

      sorted20KeysBySort.map(function (key, i) {
        sorted20.push(that.probes.metadata[key])
      });

      sorted20.map(function (m, i) {
        m['idc'] = sorted20KeysBySort[i];
        m['namec'] = m.name;
      });

      that.sorted20 = sorted20;

      this.$store.dispatch("UNSET_LOADING");
    },
    changeCustom() {

      let that = this;

      let m = {
        id: that.$route.params.id,
        filters: that.filtersCustom
      }

      that.$store.dispatch("SET_LOADING");

      that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID_AND_CUSTOM_FILTERS", m).then(function(res) {
        that.probes = that.$store.state.probesResultsListCustom;

        let sorted20KeysBySort = that.probes.top20[that.sort];
        let sorted20 = [];

        sorted20KeysBySort.map(function (key, i) {
          sorted20.push(that.probes.metadata[key])
        });

        sorted20.map(function (m, i) {
          m['idc'] = sorted20KeysBySort[i];
          m['namec'] = m.name;
        });

        that.sorted20 = sorted20;

        that.distribution = that.probes.distributions[that.display];

        that.$store.dispatch("UNSET_LOADING");
      })
    },
    changeEnableWeights(newValue) {
      let that = this;

      if (newValue) {
        that.sort = 'global';
        that.display = 'global';
        that.setDefaultWeights();
        that.changeSort(that.sort);
        that.changeCustom();
      } else {

        that.sort =  'global';
        that.display = 'global';
        that.customFiltersFlag = false;

        this.$store.dispatch("SET_LOADING");

        that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function(res) {
          that.probes = that.$store.state.probesResultsList;

          that.getFirst20(that.sort);
          that.$store.dispatch("UNSET_LOADING");
        })
      }

    },
    setDefaultWeights() {
      this.filtersCustom = {'selectivity': 8, 'target_potency': 4, 'cell_potency': 2, 'inactive_analogs': 1, 'pains': 1, 'sar': 1};
    },
    changeDisplay(name) {
      let that = this;

      this.display = name;

      that.distribution = that.probes.distributions[that.display];
    }
  },
  watch: {
    '$route' (to, from) {
      console.log(to, from)
      let that = this;

      that.portalList = [];
      that.portalList20 = [];
      that.portalListRest = [];
      that.errorPage = false;
      that.sort =  'global';
      that.display = 'global';
      that.customFiltersFlag = false;

      this.$store.dispatch("SET_LOADING");

      this.$store.dispatch("GET_TARGET_RESULTS_BY_ID", this.$route.params.id).then(function(res) {
        that.target = that.$store.state.targetResultsList;

        if (that.target) {
          that.titleName = that.target.name;
          that.$store.dispatch("GET_TARGET_PROBES_RESULTS_BY_ID", that.$route.params.id).then(function(res) {
            that.probes = that.$store.state.probesResultsList;

            if (that.$store.state.portalList) {
              that.portalList20 = that.$store.state.portalList.in_top_20;
              that.portalListRest = that.$store.state.portalList.not_in_top_20;
              that.unmapped = that.$store.state.portalList.unmapped;

              that.portalList20.map(function(m, i){
                that.portalList.push({name:m, top:true})
              })

              that.portalListRest.map(function(m, i){
                that.portalList.push({name:m, top:false})
              })

              that.$store.dispatch("UNSET_LOADING");

              that.getFirst20(that.sort);
            } else  {
              that.errorPage = true
              that.$store.dispatch("UNSET_LOADING");
            }
          })
        } else {
          that.errorPage = true
          that.$store.dispatch("UNSET_LOADING");
        }
      })
    }
  }
}
</script>

<style scoped>
.target__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.target-top__layout__summary-title{
  width: 100%;
  font-size: 30px;
  font-weight: 300;
  background-color: #455A64;
  color: white;
  margin: 0 0 5px 0;
}
.target-probes__layout-title {
  width: 100%;
  font-size: 20px;
  font-weight: 600;
  border-left: 5px solid #455A64;
  color: #455A64;
  background: rgba(0, 0, 0, .03);
}
.target-top__layout__portal-links{
  text-decoration: none;
  font-weight: 400;
}
.target-probes__layout__content__setting-btn{
  color: white;
}
.target_layout__content {
  margin: 5px 10px;
  background-color: #ffffff;
  border-radius: 2px;
}
.target_layout--loading {
  width:100%;
  text-align:center;
}
.landing-middle__layout-form {
  padding: 5% 20% 5% 20%;
  margin-bottom: 10px;
}
.section {
	clear: both;
	padding: 0px;
  margin: 10px;
}
.col {
  border: 1px solid white;
  text-align: center;
  color:white;
  width: 100%;
  padding: 5px;
  cursor: pointer;
}
.col:hover {
  background-color: rgba(255,255,255,.5);
  color: black;
}
</style>

<style>
.range-slider {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background: #d7dcdf;
  outline: none;
  padding: 0;
  margin: 0;
}

.low.range-slider{
  background: #f5c8c8;
}
.high.range-slider{
  background: #b6d2b9;
}

.range-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
          appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #2c3e50;
  cursor: pointer;
  -webkit-transition: background-color .15s ease-in-out;
  transition: background-color .15s ease-in-out;
}

.range-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border: 0;
  border-radius: 50%;
  background: #2c3e50;
  cursor: pointer;
  -webkit-transition: background-color .15s ease-in-out;
  transition: background-color .15s ease-in-out;
}

.range-slider::-webkit-slider-thumb:hover,
.range-slider:active::-webkit-slider-thumb {
  width: 25px;
  height: 25px;
}

.range-slider::-moz-range-thumb:hover,
.range-slider:active::-moz-range-thumb {
  background: #03A9F4;
  width: 30px;
  height: 30px;
}

.low::-webkit-slider-thumb:hover,
.low:active::-webkit-slider-thumb {
  background: red;
}

.high::-webkit-slider-thumb:hover,
.high:active::-webkit-slider-thumb {
  background: #1abc9c;
}

::-moz-range-track {
  background: #d7dcdf;
  border: 0;
}

input::-moz-focus-inner,
input::-moz-focus-outer {
  border: 0;
}

.row {
  display: flex;
}

.col {
  flex: 1;
  padding: 1em;
  border: solid;
}

</style>



// WEBPACK FOOTER //
// PrbCompoundSynopsis.vue?5c3ab51f